import { create } from "zustand";
import type { AuthType, UserInfoResponse } from "@/api/types";

interface UserState {
  /** 邮箱登录时展示用 */
  email: string | null;
  /** email=邮箱托管 · wallet=Web3 钱包（来自 GetUserInfo，便于分支交互） */
  authType: AuthType | null;
  userInfo: UserInfoResponse | null;
  setAuthSession: (params: {
    userInfo: UserInfoResponse | null;
    email?: string | null;
  }) => void;
  setUserInfo: (userInfo: UserInfoResponse | null) => void;
  clearUserInfo: () => void;
}

/** 用户信息全局状态（运行时内存） */
export const useUserStore = create<UserState>()(set => ({
  email: null,
  authType: null,
  userInfo: null,

  setAuthSession: ({ userInfo, email }) =>
    set(state => ({
      userInfo,
      email: email !== undefined ? email : state.email,
      authType: userInfo?.authType ?? null,
    })),

  setUserInfo: userInfo =>
    set({
      userInfo,
      authType: userInfo?.authType ?? null,
    }),

  clearUserInfo: () => set({ email: null, authType: null, userInfo: null }),
}));
